import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { omit } from "lodash";
import { Buttons } from "../../common/Buttons";
import { buttonClass } from "../../common/CSS";
import { Input } from "./Input";
import { deepEqual } from "../../utils/common";
import { setErrorUndefined } from "../../actions/auth";
import { useNavigate } from "react-router-dom";

export const FormContext = React.createContext({
  form: {},
});

export default function Form(props) {
  let {
    children,
    setForm,
    form,
    btnclass,
    submit = () => {},
    btnposition,
    formClass,
    formName,
    isPreventDefault = true,
    error,
  } = props;

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [requiredWrapper, setRequiredWrapper] = useState();
  const { formButtonLoading } = useSelector((state) => state.loadingreducer);
  const recursive = (children, required, depth) => {
    if (!children || depth > 20) return;
    const r = (child) => {
      if (typeof child === "object") {
        if (child.type === Input) {
          required[child.props.name] = child.props.required;
        } else {
          recursive(child.props.children, required, depth + 1);
        }
      }
    };
    if (Array.isArray(children)) {
      children.forEach((child) => {
        r(child);
      });
    } else {
      r(children);
    }
  };

  const getRequiredFiled = (children) => {
    let requiredObject = {};
    recursive(children, requiredObject, 0);
    return requiredObject;
  };

  useEffect(() => {
    let requiredFields = getRequiredFiled(children);
    if (!deepEqual(requiredWrapper, requiredFields)) {
      setRequiredWrapper(requiredFields);
      setErrors({});
    }
  }, [children]);

  const validate = (value, name, required, errorMessage) => {
    // dispatch(setErrorUndefined())
    if (!value && required) {
      setErrors(
        Object.assign({}, errors, {
          [`${name}`]: `${
            errorMessage ? errorMessage : `This Field is Required`
          }`,
        })
      );
    } else {
      let newObj = omit(errors, name);
      setErrors(newObj);
    }
  };

  let customValidationHandler = (
    value,
    name,
    errorMessage,
    customValidation
  ) => {
    if (!customValidation) return;
    let isValid = true;
    if (typeof customValidation === "function") {
      isValid = customValidation(value);
      if (value && !isValid) {
        setErrors(
          Object.assign({}, errors, {
            [`${name}`]: `${
              errorMessage ? errorMessage : `This Field is Required`
            }`,
          })
        );
      }
    }
    return;
  };

  const handleFileUpload = (event, errorMessage) => {
    const { name, files, required } = event.target;
    setForm({
      ...form,
      [name]: files,
    });
    validate(files, name, required, errorMessage);
  };

  const handleClearFileUpload = (files, name) => {
    setForm({
      ...form,
      [name]: [...files],
    });
  };

  const handleFormOnBlur = (event, errorMessage, customValidation) => {
    const { name, value } = event.target ? event.target : event;
    setForm({ ...form, [name]: value });
    customValidationHandler(value, name, errorMessage, customValidation);
  };

  const handleFormChange = (event, errorMessage) => {
    const { name, value, required } = event.target ? event.target : event;
    setForm({ ...form, [name]: value });
    validate(value, name, required, errorMessage);
  };

  const formSubmit = (form) => {
    let requiredErrors = [];
    for (const name in requiredWrapper) {
      let value = form[name];
      if (Array.isArray(value) && requiredWrapper[name] && value.length === 0) {
        requiredErrors.push({ [`${name}`]: `This Field is Required` });
      } else if (
        requiredWrapper[name] &&
        name === "mobile" &&
        value?.length !== 10
      ) {
        requiredErrors.push({
          [`${name}`]:
            value.length < 2
              ? `This Field is Required`
              : `Please enter valid mobile number`,
        });
      } else if (requiredWrapper[name] && !value) {
        requiredErrors.push({ [`${name}`]: `This Field is Required ` });
      }
    }
    setErrors(Object.assign({}, errors, ...requiredErrors));
    if (
      requiredErrors.length === 0 &&
      Object.keys(form).length !== 0 &&
      Object.keys(errors).length === 0
    ) {
      submit(form);
    }
  };

  useEffect(() => {
    if (form?.address?.length > 0 && requiredWrapper) {
      requiredWrapper["address"] = false;
    } else if (form?.pincode?.length === 6 && requiredWrapper) {
      requiredWrapper["pincode"] = false;
    }
  }, [form?.address, form?.pincode]);

  const handleFormSubmit = (event) => {
    if (event.keyCode === 13 && isPreventDefault && !event.shiftKey) {
      event.preventDefault();
      formSubmit(form);
    }
    if (event.type === "click") {
      event.preventDefault();
      formSubmit(form);
    }
  };

  return (
    <>
      <form
        className={`Form ${formClass}`}
        onKeyDown={(event) => handleFormSubmit(event)}
      >
        <FormContext.Provider
          value={{
            form,
            errors,
            error,
            handleFileUpload,
            handleFormChange,
            handleFormOnBlur,
            handleClearFileUpload,
          }}
        >
          <div>{children}</div>
        </FormContext.Provider>

        {props?.btnText?.show === true ? (
          <div className="w-full m-auto text-center mt-8 flex">
            <Buttons
              btnText="Tickets History"
              classN={`${buttonClass?.scogoPrimary} w-43% mr-6 pb-2 pt-2 `}
              onClick={() => {
                navigate("/ticket");
              }}
            />
            <Buttons
              btnText={props?.btnText?.title}
              classN={`${buttonClass?.scogoOrange} w-43%  rounded-md  pb-2 pt-2`}
              loading={formButtonLoading?.[formName]}
              onClick={(e) => handleFormSubmit(e)}
            />
          </div>
        ) : (
          <div className={`px-6 pb-4 pt-3 ${btnposition}`}>
            <Buttons
              classN={`${buttonClass?.scogoOrange} ${btnclass}`}
              btnText={props?.btnText ? props.btnText : "Next"}
              loading={formButtonLoading?.[formName]}
              onClick={(e) => handleFormSubmit(e)}
            />
          </div>
        )}
      </form>
    </>
  );
}
